import { CategoryBadge } from "@simplicity/ui";
import { DEFAULT_LAYER_COLOR, LAYER_COLORS, LAYER_LABELS } from "./layerStyle";

export function LayerBadge({ layer }: { layer: string }) {
  const color = LAYER_COLORS[layer] ?? DEFAULT_LAYER_COLOR;
  const label = LAYER_LABELS[layer] ?? layer;
  return <CategoryBadge color={color}>{label}</CategoryBadge>;
}
